import { InterceptAmfService } from './../intercept/intercept-amf.service';
import {Injectable} from '@angular/core';
import {AmfAbstractService} from "../amf-abstract.service";
import {JSessionIdCookieService} from "../../storage/usuario/jsession-id-cookie.service";
import {ResponseAmf} from "../../model/shared/response-amf";
import {ManutencaoSenha} from "../../model/usuario/manutencao-senha";
import {Usuario} from "../../model/usuario/usuario";
import { ServiceConst } from '../../const/shared/service-const';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService extends AmfAbstractService {

    constructor(
        private _jSessionIdCookieService: JSessionIdCookieService, 
        private _interceptAmfService: InterceptAmfService) {
        super(ServiceConst.USUARIO);
    }

    alterarSenha(manutencaoSenha: ManutencaoSenha): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'AlterarSenha', [manutencaoSenha.usuario, manutencaoSenha.senhaAntiga, manutencaoSenha.considerarSenhaAntiga], this._jSessionIdCookieService.get());
    }

    listar(filtro: number, numIni: number, numFim: number, params: string[]): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'Listar', [filtro, numIni, numFim, params], this._jSessionIdCookieService.get());
    }

    locate(id: number): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'Locate', [id], this._jSessionIdCookieService.get());
    }

    async saveOrUpdate(usuario: Usuario): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'SaveOrUpdate', [usuario], this._jSessionIdCookieService.get());
    }

    excluir(id: number) {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'Excluir', id, this._jSessionIdCookieService.get());
    }

    ListarExterno(filtro: number, numIni: number, numFim: number, params: string[]): Promise<ResponseAmf> {
        return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.USUARIO, 'Listar', [filtro, numIni, numFim, params], this._jSessionIdCookieService.get());
    }
 
}
